<template>
  <div
    class="text-dark d-flex p-1 rounded-1 justify-content-between e-document"
    style="cursor: pointer"
  >
    <div
      class="d-flex flex-grow-1"
      @click="downloadFile"
    >
      <feather-icon
        icon="FileTextIcon"
        size="20"
        class="mr-1"
      />
      {{ fileName }}
    </div>
    <slot />
  </div>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'

export default {
  name: 'PrivateFileDownload',
  props: {
    fileUrl: {
      type: String,
      required: true,
    },
    fileName: {
      type: String,
      required: true,
    },
  },
  methods: {
    ...mapMutations('app', {
      setLoading: 'loading',
    }),
    ...mapMutations({
      setNotifications: 'notifications',
      setShowNotifications: 'setShowNotifications',
    }),
    async downloadFile() {
      this.setLoading(true)
      try {
        const token = JSON.parse(localStorage.getItem('token'))
        const response = await axios.get(this.fileUrl, {
          responseType: 'blob',
          headers: {
            Authorization: `${token.token_type} ${token.token}`,
          },
        })

        // Normalizar el nombre del archivo
        const normalizedFileName = this.fileName.replace(/\s+/g, '_')

        // Crear un blob y descargar el archivo
        const url = URL.createObjectURL(response.data)
        const link = document.createElement('a')
        link.href = url
        link.download = normalizedFileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      } catch (error) {
        console.error('Error al descargar el archivo:', error)
        this.setNotifications({ title: 'Error al descargar el archivo.', variant: 'danger' })
        this.setShowNotifications(true)
      } finally {
        this.setLoading(false)
      }
    },
  },
}
</script>
